import React, { useState, useEffect } from 'react'
import PhoneInput from 'react-phone-input-2'
import { Form } from 'react-bootstrap'
import { Row, Col } from 'react-bootstrap'
import { getIn } from 'formik'
import * as Yup from 'yup'
import 'react-phone-input-2/lib/bootstrap.css'
import { PhoneNumberUtil } from 'google-libphonenumber'
const phoneUtil = PhoneNumberUtil.getInstance()
const { Group, Label } = Form

var countryCodeForValidation = null
var selectedCountryISO = null
let longDigitCountries = ['ar', 'at', 'mx', 'fi']

export const phoneNumberRequiredValidator = () =>
  Yup.string().test('phoneNumber', 'Enter phone number', function(value) {
    if (!value) {
      return false
    } else if (countryCodeForValidation) {
      let code = '+' + countryCodeForValidation
      if (value === code || value === '+') {
        return false
      } else {
        return true
      }
    }
    countryCodeForValidation = null
    return true
  })

export const phoneNumberValidator = ({ message } = {}) =>
  Yup.string().test('phoneNumber', 'Invalid phone number format', function(
    value
  ) {
    if (window.location.href.includes('localhost')) {
      return true
    }
    if (value && countryCodeForValidation) {
      const number = phoneUtil.parseAndKeepRawInput(
        value,
        selectedCountryISO.iso2
      )
      const isValidNumber = phoneUtil.isValidNumber(number)
      let code = '+' + countryCodeForValidation
      let testString = value.replace(code, '')

      if (testString[0] === '0' || !isValidNumber) {
        if (!isValidNumber && selectedCountryISO.iso2 === 'ar') {
          return testString.length === 10 && /^\d+$/.test(testString)
        }
        return false
      } else {
        return true
      }
    }
    countryCodeForValidation = null
    return true
  })

export default function FormInputPhoneNew({
  field: { value = '', ...field } = {},
  form: {
    touched = {},
    errors = {},
    setFieldValue = () => {},
    setTouched = () => {},
  } = {},
  icon,
  groupProps = {},
  handleChange,
  hintText,
  label,
  controlId,
  countryCode = null,
  checkZeroInvalid = false,
  enableLongNumbers = false,
  className,
  callOnClick = false,
  equalFields = false,
  isBook = false,
  isCarRental = false,
  ...props
}) {
  const showError = !!getIn(touched, field.name) && !!getIn(errors, field.name)
  const [isCountry, setCountry] = useState(countryCode ? countryCode : 'gb')
  const onChange = e => {
    countryCodeForValidation = isCountry.countryCode
    setFieldValue(field.name, `+${e}`)
    if (handleChange) {
      handleChange(value, isCountry)
    }
  }

  useEffect(() => {
    countryCodeForValidation = isCountry.countryCode
    selectedCountryISO = isCountry
  }, [isCountry])

  return (
    <Group controlId={controlId || field.name}>
      {!!label && <Label className='form-label'>{label}</Label>}
      <Row
        className={
          `phone-field-row`
        }
      >
        <Col xs={12} md={12} className={className || ''}>
          <PhoneInput
            inputClass={`phone-input ${showError ? 'is-invalid' : ''}`}
            placeholder=''
            isValid={(value, country, showError) => {
              setCountry(country)
              if (country && value.length > 2) {
                const number = phoneUtil.parseAndKeepRawInput(
                  value,
                  country.iso2
                )
                if (phoneUtil.isValidNumber(number)) {
                  return true
                } else if (!phoneUtil.isValidNumber(number)) {
                  return false
                }
              } else {
                if (value.match(/12345/)) {
                  return false
                } else if (value.match(/1234/)) {
                  return false
                } else {
                  return true
                }
              }
            }}
            containerClass='phone-number-input'
            country={countryCode ? countryCode : 'gb'}
            value={value}
            inputProps={
              longDigitCountries.includes(isCountry.iso2) && enableLongNumbers
                ? {
                    type: 'text',
                    value: value,
                  }
                : {
                    type: 'text',
                  }
            }
            onChange={phone => onChange(phone)}
            // onFocus={onFocus}
            // onBlur={onBlur}
            enableLongNumbers={
              longDigitCountries.includes(isCountry.iso2) ? 1 : false
            }
          />
          {callOnClick && (
            <Col className='phone-button-form' lg={12}>
              <a href={`tel:${value}`}>
                <img width='15px' src='/images/icons/phone.svg' alt='' />
              </a>
            </Col>
          )}
          {!!showError && (
            <div className='invalid-feedback d-block'>
              {getIn(errors, field.name)}
            </div>
          )}
        </Col>
      </Row>
    </Group>
  )
}
